import { render } from "./ModalChooseUploadOption.vue?vue&type=template&id=b0df5be2&scoped=true"
import script from "./ModalChooseUploadOption.vue?vue&type=script&lang=js"
export * from "./ModalChooseUploadOption.vue?vue&type=script&lang=js"

import "./ModalChooseUploadOption.vue?vue&type=style&index=0&id=b0df5be2&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0df5be2"]])

export default __exports__